import styled from 'styled-components';

export const BenfitTypeName = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #162056;
`;

export const Bold = styled.span`
  font-weight: ${props => props.theme.fontBold};
`;

export const Italic = styled.span`
  font-style: italic;
`;
